import { createContext, useContext, useEffect, useState } from 'react';
import { getNavigation, saveNavigation } from '../utils/navigationHelper';

const NavigationContext = createContext(null);

const initial = {
  acitveAppKey: null,
  acitveProgramId: null,
  activeResourceId: null
};

export const NavigationContextProvider = ({ children }) => {
  const [navigationContext, setNavigationContext] = useState(getNavigation() || initial);

  useEffect(() => {
    if (navigationContext && navigationContext.acitveAppKey !== null) {
      saveNavigation(navigationContext);
    }
  }, [navigationContext]);

  const openProgramDetail = (targetProgram) => {
    setNavigationContext({
      ...navigationContext,
      acitveAppKey: 'program',
      acitveProgramId: targetProgram?.id
    });
  };

  const openResourceDetail = (targetResource) => {
    setNavigationContext({
      ...navigationContext,
      acitveAppKey: 'resource',
      activeResourceId: targetResource?.id
    });
  };

  const openEventDetail = (targetEvent) => {
    setNavigationContext({
      ...navigationContext,
      acitveAppKey: 'mmevent',
      acitveEventId: targetEvent?.id
    });
  };

  const openMSEventDetail = (targetEvent) => {
    setNavigationContext({
      ...navigationContext,
      acitveAppKey: 'msevent',
      acitveEventId: targetEvent?.id
    });
  };

  const openKBEventDetail = (targetEvent) => {
    setNavigationContext({
      ...navigationContext,
      acitveAppKey: 'kbevent',
      acitveEventId: targetEvent?.id
    });
  };

  const openProjectDetail = (targetProject) => {
    setNavigationContext({
      ...navigationContext,
      acitveAppKey: 'ddproject',
      acitveProjectId: targetProject?.id
    });
  };

  const openProductDetail = (targetProduct) => {
    setNavigationContext({
      ...navigationContext,
      acitveAppKey: 'ddproduct',
      acitveProductId: targetProduct?.id
    });
  };

  const openAnalytics = (targetProduct) => {
    setNavigationContext({
      ...navigationContext,
      acitveAppKey: 'analytics',
      acitveProductId: targetProduct?.id
    });
  };

  const openCNProjectDetail = (targetProject) => {
    setNavigationContext({
      ...navigationContext,
      acitveAppKey: 'cnproject',
      acitveProjectId: targetProject?.id
    });
  };

  const openBACEventDetail = (targetEvent) => {
    setNavigationContext({
      ...navigationContext,
      acitveAppKey: 'bacevent',
      acitveEventId: targetEvent?.id
    });
  };

  const openBACNewsDetail = (targetNews) => {
    setNavigationContext({
      ...navigationContext,
      acitveAppKey: 'bacnews',
      acitveNewsId: targetNews?.id
    });
  };

  const openSYInternalResourceDetail = (targetResource) => {
    setNavigationContext({
      ...navigationContext,
      acitveAppKey: 'syinternalresource',
      acitveInternalResourceId: targetResource?.id
    });
  };

  const openSYExternalResourceDetail = (targetResource) => {
    setNavigationContext({
      ...navigationContext,
      acitveAppKey: 'syexternalresource',
      acitveExternalResourceId: targetResource?.id
    });
  };

  const openSYEventDetail = (targetEvent) => {
    setNavigationContext({
      ...navigationContext,
      acitveAppKey: 'syevent',
      acitveEventId: targetEvent?.id
    });
  };

  const openCNGProjectDetail = (targetProject) => {
    setNavigationContext({
      ...navigationContext,
      acitveAppKey: 'cngproject',
      acitveProjectId: targetProject?.id
    });
  };

  const openCNGNewsDetail = (targetProject) => {
    setNavigationContext({
      ...navigationContext,
      acitveAppKey: 'cngnews',
      acitveNewsId: targetProject?.id
    });
  };

  const openCNGProjectHighlightDetail = (targetProject) => {
    setNavigationContext({
      ...navigationContext,
      acitveAppKey: 'cngprojecthighlight',
      acitveProjectId: targetProject?.id
    });
  };

  const openPRNACircumstanceDetail = (targetProject) => {
    setNavigationContext({
      ...navigationContext,
      acitveAppKey: 'prnacircumstance',
      acitveCircumstanceId: targetProject?.id
    });
  };

  const openPRNAProjectDetail = (targetProject) => {
    setNavigationContext({
      ...navigationContext,
      acitveAppKey: 'prnaproject',
      acitveProjectId: targetProject?.id
    });
  };

  return (
    <NavigationContext.Provider
      value={{
        navigationContext,
        setNavigationContext,
        openProgramDetail,
        openResourceDetail,
        openEventDetail,
        openProjectDetail,
        openProductDetail,
        openAnalytics,
        openCNProjectDetail,
        openKBEventDetail,
        openMSEventDetail,
        openBACEventDetail,
        openBACNewsDetail,
        openSYEventDetail,
        openSYInternalResourceDetail,
        openSYExternalResourceDetail,
        openCNGProjectDetail,
        openCNGNewsDetail,
        openCNGProjectHighlightDetail,
        openPRNACircumstanceDetail,
        openPRNAProjectDetail
      }}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigationContext = () => {
  return useContext(NavigationContext);
};
